import { PublicClientApplication } from "@azure/msal-browser";
import appStorage from "utilities/app-storage";
import {loginRequest} from "../configs/MsalConfig";
import { Utilities } from "utilities/utilities";
import { msalInstance } from "msalInstance";


/**
 * Class to handle authentication operations.
 */
export class AuthOperations {
  publicClientApplication: PublicClientApplication | undefined;

  /**
   * Indicates if a token API call is in progress to avoid multiple token requests.
   * @private
   * @type {boolean}
   */
  private callInProgress = false;

  private refreshPromise: Promise<void> | null = null;

  /**
   * Retrieves a new access token if the current token is about to expire.
   * If the token expires in 10 minutes or less and no refresh call is already in progress,
   * it initiates a silent token acquisition process. If the acquisition fails,
   * the user is logged out.
   */
  async getRefreshToken(): Promise<void> {
    const timeLeft = Utilities.timeLeftInTokenExpiration();

    if (timeLeft > 10) {
      return;
    }

    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    const account = msalInstance.getAllAccounts()[0];

    if (!account) {
      Utilities.redirectToLogout();
      return;
    }

    this.callInProgress = true;
    this.refreshPromise = msalInstance
      .acquireTokenSilent({
        ...loginRequest,
        account: account,
        forceRefresh: true,
      })
      .then((authResponse) => {
        if (!authResponse) {
          Utilities.redirectToLogout();
          return;
        }

        appStorage.setAccessToken(authResponse.accessToken);

        if (authResponse.expiresOn != null) {
          appStorage.setExpirationTime(authResponse.expiresOn);
        }
      })
      .catch((error) => {
        Utilities.redirectToLogout();
        return;
      })
      .finally(() => {
        this.callInProgress = false;
        this.refreshPromise = null;
      });

    return this.refreshPromise;
  }
 
}

const authOperations = new AuthOperations();
export default authOperations;